export default {
	tasks: {
		createTask: 'Wiedervorlage erstellen',
		taskType: 'Wiedervorlage Art',
		requireIntervention: 'Sofortige Bearbeitung erforderlich',
		dueNextWeek: 'Fällig in den nächsten 7 Tagen',
		scheduledFuture: 'Geplant für die Zukunft',
	},
}
